<template>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary" style="position: sticky; top: 0; z-index: 1">
                <v-btn icon dark @click="close"><v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title>Novo Relatório</v-toolbar-title>
                <v-spacer/>
                <v-toolbar-items>
                    <v-btn dark text @click="save" :disabled="!valid">Salvar</v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="mt-5">
                <v-form id="formCadastroMonitoramentoIndicador" ref="formCadastroMonitoramentoIndicador" v-model="valid" lazy-validation >
                    <v-row>
                        <v-col cols="12" md="2">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="item.data" label="Data" :rules="fieldRules" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="item.data" no-title/>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="10">
                          <v-autocomplete v-model="item.projetoId" :items="projetos" :loading="isProjetoLoading" :search-input.sync="searchProjeto" hide-no-data hide-selected clearable
                              item-text="codigoNome" item-value="id" label="Projeto" :placeholder="item.projeto ? item.projeto.codigoNome : 'Digite um projeto'" @change="CarregarItens()" dense outlined/>
                        </v-col>
                    </v-row>

                    <v-data-table :headers="headers" :items="itens" :items-per-page="-1" :hide-default-footer="true" class="elevation-1">

                        <template v-slot:[`item.comentario`]="{ item }">
                            <div class="comentario">
                                <v-textarea style="margin-bottom: -25px" v-model="item.comentario" dense outlined/>
                            </div>
                        </template>

                        <template v-slot:[`item.documento`]="{ item }">
                            <div class="documento">
                                <v-chip v-if="item.documento" close @click:close="Excluir(item)" color="primary" small><v-icon @click="Download(item)" class="mr-4">mdi-download</v-icon><span class="text-truncate">{{ item.documento }}</span></v-chip>
                                <v-file-input v-else accept=".pdf" v-model="item.salvarArquivo"/>
                            </div>
                        </template>

                        <template v-slot:[`item.status`]="{ item }">
                            <div class="status">
                                <v-select v-model="item.status" :items="status" :rules="fieldRules" item-value="key" item-text="value" />
                            </div>
                        </template>

                    </v-data-table>

                </v-form>
            </v-card-text>
        </v-card>

        <v-overlay :value="isLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </v-dialog>

</template>
<script>
import { MonitoramentoIndicadorService, StatusIndicadorEnumService } from '@/core/services/projetos/monitoramento';
import { MonitoramentoIndicador, MonitoramentoIndicadorItem } from '@/core/domain/projetos/monitoramento/';
import ProjetoService from '@/core/services/projetos/ProjetoService';
import jiff from 'jiff';

export default {
    props:{
        item: {
            required: true
        },
        value: {}
    },
    watch: { 
        item: function() { 
            if ('formCadastroMonitoramentoIndicador' in this.$refs)
                this.$refs.formCadastroMonitoramentoIndicador.resetValidation();

            if(this.item.id > 0){
                this.CarregarItens();
            } 
        },
        value: function() {
            this.dialog = this.value;
        },
        dialog: function() {
            if (!this.dialog) {
                this.$emit('fechou');
            }
            if(this.dialog){
                this.itemOriginal = jiff.clone(this.item);
            }
        },
        searchProjeto (val) {
            if (this.item.projetoId) return;
            if (this.isProjetoLoading) return;
            if (!val) return;
            
            this.isProjetoLoading = true
            const projetoService = new ProjetoService();
            projetoService.AutoComplete(val)
                .then(
                    res => {
                        this.projetos = res.data;
                    },
                    err => this.$swal('Aviso', err.response.data, 'error')
                )
                .finally(() => (this.isProjetoLoading = false))
        }
    },
    data: () => ({
        itemOriginal: null,
        service: new MonitoramentoIndicadorService(),
        statusService: new StatusIndicadorEnumService(),
        valid: true,
        dialog: false,
        isLoading: false,
        isProjetoLoading: false,
        searchProjeto: null,
        projetos: [],
        status: [],
        headers: [
            { text: '', sortable: false  },
            { text: 'Indicadores', value:'indicadores' },
            { text: 'Meios Verificação', value:'meiosVerificacao' },
            { text: 'Período Verificação', value:'periodoVerificacao' },
            { text: 'Comentários', value:'comentario' },
            { text: 'Documento', value:'documento' },
            { text: 'Status', value:'status' }
        ],
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],
        sessionApp: {},
        itens: []
    }),
    methods: {

        CarregarItens(){

            if(this.item.projetoId == undefined)
                return;

            this.isLoading = true;

            this.service.ObterCompleto(this.item.id, this.item.projetoId).then(
                res =>{                    
                    res.data.forEach(x => {
                        let item = new MonitoramentoIndicadorItem();
                        item.empresaId = this.item.empresaId;
                        item.monitoramentoIndicadorId = this.item.id;
                        item.projetoId = x.projetoId;
                        item.comentario = x.comentario;
                        item.documento = x.documento;
                        item.indicadores = x.indicadores;
                        item.status = x.status;
                        item.periodoVerificacao = x.periodoVerificacao;
                        item.meiosVerificacao = x.meiosVerificacao;
                        item.indicadorId = x.indicadorId;
                        item.id = x.id;
                        this.itens.push(item);
                    });
                },
                err => this.$swal('Aviso', err.response.data, 'error')
            ).finally(() => {
                this.isLoading = false;
            })
        },
        save() {

            if (this.$refs.formCadastroMonitoramentoIndicador.validate()) {
                
                if(this.item.id > 0){

                    let patchModel = jiff.diff(this.itemOriginal, this.item, false);

                    this.service.SalvarPatch(patchModel,this.itemOriginal.id).then(
                        res => {     
                            this.AlterarItem(this.item.id, this.itens)
                        },
                        err =>  {
                            if (err.response.status == 400) {
                                this.$swal('Aviso', err.response.data.title, 'warning')    
                            }
                            else {
                                this.$swal('Aviso', err.response.data, 'error')
                            }
                        }
                    )
                }
                else{
                    
                    this.item.itens = this.itens;

                    let modelo = new MonitoramentoIndicador(this.item);

                    this.item.itens.forEach(x => {
                        x.id = this.item.itens.indexOf(x) + 1;
                    });

                    this.service.Salvar(modelo).then(
                        res => {   
                            if(this.itens.length > 0){ 
                                this.itens.forEach(model => {
                                    if(model.salvarArquivo){
                                        this.EnviarDocumento(res.data.id, model.id, model.salvarArquivo).then(
                                            res => {
                                                this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                                                this.$emit('salvou');
                                                this.close();
                                            },
                                            err => {
                                                if (err.response.status == 400) {
                                                    this.$swal('Aviso', err.response.data.title, 'warning')    
                                                }
                                                else {
                                                    this.$swal('Aviso', err.response.data, 'error')
                                                }
                                            }
                                        )
                                    }
                                    else {
                                        this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                                        this.$emit('salvou');
                                        this.close();
                                    }
                                });
                            }      
                            else{
                                this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                                this.$emit('salvou');
                                this.close();
                            }                    
                        }, 
                        err =>  {
                            if (err.response.status == 400) {
                                this.$swal('Aviso', err.response.data.title, 'warning')    
                            }
                            else {
                                this.$swal('Aviso', err.response.data, 'error')
                            }
                        }
                    )
                }
            }
        },
        AlterarItem(monitoramentoId, models){

            models.forEach(model => {
                this.service.AlterarItens(model.id, monitoramentoId, model).then(
                    res => {
                        if(model.salvarArquivo){
                            this.EnviarDocumento(this.item.id, model.id, model.salvarArquivo).then(
                                res => {
                                    this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                                    this.$emit('salvou');
                                    this.close();
                                },
                                err => {
                                    if (err.response.status == 400) {
                                        this.$swal('Aviso', err.response.data.title, 'warning')    
                                    }
                                    else {
                                        this.$swal('Aviso', err.response.data, 'error')
                                    }
                                }
                            )
                        }
                        else {
                            this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                            this.$emit('salvou');
                            this.close();
                        }
                    },
                    err =>  {
                        if (err.response.status == 400) {
                            this.$swal('Aviso', err.response.data.title, 'warning')    
                        }
                        else {
                            this.$swal('Aviso', err.response.data, 'error')
                        }
                    }
                )
            });
            
        },
        Download(item){
            this.service.DownloadDocumento(item.monitoramentoIndicadorId, item.documento);
        },
        Excluir(item){

            this.service.DeletarDocumento(item.monitoramentoIndicadorId, item.id ,item.documento).then(
                res =>{
                    this.itens.find(x => x == item).documento = "";
                }, 
                err =>  {
                    if (err.response.status == 400) {
                        this.$swal('Aviso', err.response.data.title, 'warning')    
                    }
                    else {
                        this.$swal('Aviso', err.response.data, 'error')
                    }
                }
            )
        },
        async EnviarDocumento(monitoramentoIndicadorId, monitoramentoIndicadorItemId, arquivoEnviar){
        
            return new Promise(async (resolve, reject) => {

                let arquivo = await this.Ler(arquivoEnviar);

                this.service.EnviarDocumento(monitoramentoIndicadorId, monitoramentoIndicadorItemId, arquivoEnviar.name, arquivo).then(
                    res => resolve(res),
                    err => reject(err)
                )

            });
        },
        async Ler(arquivo) {
            return new Promise((resolve, reject) => {
            let fr = new FileReader();
        
            fr.onload = (arquivo) => {
                resolve(arquivo.target.result);
            };
        
            fr.readAsArrayBuffer(arquivo);
            });
        },
        close() {
            this.dialog = false;
            this.itens = [];
        }
    },
    beforeUpdate(){
        if (!this.dialog){
            this.$emit('fechou');
        }
    },
    mounted() {

        this.sessionApp = JSON.parse(localStorage.sessionApp);

        this.statusService.Listar().then(
            res => {
                this.status = res.data;
            },
            err => this.$swal('Aviso', err.message, 'error')
        );
    }
}
</script>

<style>
@media only screen and (pointer: fine){
    .comentario {
        width: 20vw;
    }
    .documento {
        width: 18vw;
    }
    .status {
        width: 12vw;
    }
}
@media only screen and (hover: none) and (pointer: coarse){
    .comentario {
        padding-left: 0px;
        width: 50vw;
    }
    .documento {
        width: 50vw;
    }
    .status {
        width: 50vw;
    }
}
</style>